import { DEFAULT_LOCALE, LANG_CODE_COOKIE_DOMAIN, locales } from '@/constants/locales'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales,

  // Used when no locale matches
  defaultLocale: DEFAULT_LOCALE,

  localePrefix: 'as-needed',

  localeCookie: {
    ...(process.env.NODE_ENV === 'production' && {
      domain: LANG_CODE_COOKIE_DOMAIN,
    }),
    // Expire in one year
    maxAge: 60 * 60 * 24 * 365,
  },
})
